export const AUTH_TOKEN = 'axxence_auth_token';

export const cookiesSetting = { path: '/' };
